frontApp.reviewsSorting = {
  init() {
    this.sortingSet();
  },
  sortingSet() {
    const $set = $('.js-reviews-sorting-set');
    if (!$set.length) {
      return;
    }
    $.each($set, function () {
      const $curSet = $(this);
      const savedSortingType = localStorage.getItem('review_sorting_type');
      const savedSortingDirection = localStorage.getItem('review_sorting_direction');
      if (savedSortingType) {
        $curSet
          .find('.js-reviews-sorting-set-el')
          .filter('.is-active')
          .removeClass('is-active asc desc');
        $curSet
          .find(`[data-sort="${savedSortingType}"]`)
          .addClass(`is-active ${savedSortingDirection}`);
      }
      $curSet.on('click', '.js-reviews-sorting-set-el', function (e) {
        e.preventDefault();
        const $curEl = $(this);
        if (!$curEl.hasClass('is-active')) {
          $curEl.addClass('is-active asc');
          $curEl
            .parent()
            .siblings()
            .children()
            .removeClass('is-active asc desc');
          localStorage.setItem('review_sorting_type', $curEl.attr('data-sort'));
          localStorage.setItem('review_sorting_direction', 'asc');
          return;
        }

        if ($curEl.hasClass('asc')) {
          $curEl
            .removeClass('asc')
            .addClass('desc');
          localStorage.setItem('review_sorting_direction', 'desc');
        } else {
          $curEl
            .removeClass('desc')
            .addClass('asc');
          localStorage.setItem('review_sorting_direction', 'asc');
        }
      });
    });
  },
};
